import { 
  USER_REQUEST, 
  USER_ERROR, 
  USER_SUCCESS, 
  USER_EMPTY, 
  USER_REQUEST_BY_ID, 
  USER_REQUEST_BY_ID_SUCCESS,
  USER_UPDATE,
  USER_ADD,
  USER_DELETE,
  USER_SEND_COI_REMINDER,
  USER_UPDATE_COI,
  USER_CLEAR_DATA,
} from '../actions/user'

import Api from '@/services/Api'

import { UserRoles } from '@/lib/userRoles';

  // UserRoles.office
  // UserRoles.guidelinesAndPublicationsCouncil
  // UserRoles.submitter
  // UserRoles.committeeUser

const state = {
  status: '',
  user: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{},
};

const getters = {
  userDataLoaded: () => {
    return state.user.id > 0;
  },
  getUserData: state => state.user,
  isSuperUser: state => { 
    if (typeof state.user.role == "undefined") {
      return false;
    }

    return state.user.role == UserRoles.office;
  },
  isSubmitter: state => {
    if (typeof state.user.role == "undefined") {
      return false;
    }

    return state.user.role == UserRoles.submitter;
  },
  isGpc: state => {
    if (typeof state.user.role == "undefined") {
      return false;
    }
    return state.user.role == UserRoles.guidelinesAndPublicationsCouncil;
  },
  isIgo: state => {
    if (typeof state.user.role == "undefined") {
      return false;
    }
    return state.user.role === UserRoles.internalGroupsOfficer;
  },
  isCommitteeUser: state => {
    if (typeof state.user.role == "undefined") {
      return false;
    }
    return state.user.role == UserRoles.committeeUser;
  },
  isNationalDelegate: state => {
    if (typeof state.user.role == "undefined") {
      return false;
    }
    return state.user.role == UserRoles.nationalDelegate;
  }
};

const actions = {
  [USER_REQUEST]: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      Api().get('/user')
      .then(function (response) {
        //Store user data to local storage
        localStorage.setItem('user', JSON.stringify(response.data.data));
        commit(USER_SUCCESS);
        commit('store_user', response);

        resolve(response);
      })
      .catch(function (error) {
        commit(USER_ERROR);
        reject(error);
      });
    })
  },

  [USER_REQUEST_BY_ID]: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST);
      Api().get('/users/' + id)
      .then(function (response) {
        commit(USER_REQUEST_BY_ID_SUCCESS);

        resolve(response);
      })
      .catch(function (error) {
        commit(USER_ERROR);
        reject(error);
      });
    })
  },

  [USER_UPDATE]: ({commit}, user) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      Api().patch('/users/' + user.id, user)
      .then(function (response) {
        commit(USER_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(USER_ERROR);
        reject(error);
      });
    })
  },

  [USER_UPDATE_COI]: ({commit}, users) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      Api().post('/users-update-coi/', {users: users})
      .then(function (response) {
        commit(USER_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(USER_ERROR);
        reject(error);
      });
    })
  },

  [USER_ADD]: ({commit}, user) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      Api().post('/users/', user)
      .then(function (response) {
        commit(USER_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(USER_ERROR);
        reject(error);
      });
    })
  },
  [USER_CLEAR_DATA]: ({commit}) => {
    commit(USER_CLEAR_DATA);
  },
  [USER_DELETE]: ({commit}, user) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      Api().delete('/users/' + user.id)
      .then(function (response) {
        commit(USER_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(USER_ERROR);
        reject(error);
      });
    })
  },

  [USER_SEND_COI_REMINDER]: ({commit}, user) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)
      Api().post('/user_coi_reminder/' + user.id)
        .then(function (response) {
          commit(USER_SUCCESS);
          resolve(response);
        })
        .catch(function (error) {
          commit(USER_ERROR);
          reject(error);
        });
    });
  }
};

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [USER_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [USER_REQUEST_BY_ID_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [USER_EMPTY]: (state) => {
    state.status = 'empty';
  },
  [USER_ERROR]: (state) => {
    state.status = 'error';
  },

  [USER_CLEAR_DATA]: state => {
    state.user = {};
  },

  store_user (state, response) {
    state.user = response.data.data;
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
